// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.needs-attention-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.needs-attention-header .error-icon {
  width: 1.4rem;
  height: 1.4rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderCatalogRegistrationHistory/NeedsAttentionTabHeader/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,cAAA;AACJ","sourcesContent":[".needs-attention-header {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n\n  .error-icon {\n    width: 1.4rem;\n    height: 1.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
